import React, { useState, useEffect } from 'react';
import classes from "./form.module.css"
import InputField from "../../../containers/inputField/inputField";
import { sixYardAxios } from '../../../../sixYardAxios';
import PromptMessage from '../../../containers/promptMessage/promptMessage';

const Form = (props) => {
    const activityTypes = props.activityTypes?.map(type => ({
        value: type.id,
        displayValue: type.name
    }));
    const [isTermsChecked, setIsTermsChecked] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [loading, setLoading] = useState(false);
    const [controls, setControls] = useState({
        eventType: {
            elementType: "select",
            elementConfig: {
                type: "select",
                placeholder: parseInt(localStorage.getItem('language')) === 1 ? "Select type" : "اختر النوع",
                options: activityTypes
            },
            value: "",
            validation: {
                required: true,
            },
            label: parseInt(localStorage.getItem('language')) === 1 ? "Event Type" : "نوع الفعالية",
            valid: false,
            touched: false
        },
        startingDate: {
            withIcon: true,
            elementType: "input",
            elementConfig: {
                type: "calendarDate",
                placeholder: parseInt(localStorage.getItem('language')) === 1 ? "Select date" : "اختر التاريخ",
            },
            value: "",
            availableDates: props.availableSlots,
            validation: {
                required: true,
            },
            label: parseInt(localStorage.getItem('language')) === 1 ? "Starting Date" : "تاريخ البداية",
            valid: false,
            touched: false
        },
        endingDate: {
            withIcon: true,
            elementType: "input",
            elementConfig: {
                type: "calendarDate",
                placeholder: parseInt(localStorage.getItem('language')) === 1 ? "Select date" : "اختر التاريخ",
            },
            value: "",
            availableDates: props.availableSlots,
            validation: {
                required: true,
            },
            label: parseInt(localStorage.getItem('language')) === 1 ? "Ending Date" : "تاريخ النهاية",
            valid: false,
            touched: false
        },
        startingTime: {
            elementType: "select",
            elementConfig: {
                type: "text",
                placeholder: parseInt(localStorage.getItem('language')) === 1 ? "Select time" : "اختر الوقت",
                options: []
            },
            value: "",
            validation: {
                required: true,
            },
            label: parseInt(localStorage.getItem('language')) === 1 ? "Starting Time" : "وقت البداية",
            valid: false,
            touched: false
        },
        endingTime: {
            elementType: "select",
            elementConfig: {
                type: "text",
                placeholder: parseInt(localStorage.getItem('language')) === 1 ? "Select time" : "اختر الوقت",
                options: []
            },
            value: "",
            validation: {
                required: true,
            },
            label: parseInt(localStorage.getItem('language')) === 1 ? "Ending Time" : "وقت النهاية",
            valid: false,
            touched: false
        },
        yourName: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: parseInt(localStorage.getItem('language')) === 1 ? "Enter name" : "أدخل الاسم",
            },
            value: "",
            validation: {
                required: true,
                minLength: 6,
                maxLength: 32,
            },
            label: parseInt(localStorage.getItem('language')) === 1 ? "Your Name" : "اسمك",
            valid: false,
            touched: false
        },
        email: {
            elementType: "input",
            elementConfig: {
                type: "email",
                placeholder: parseInt(localStorage.getItem('language')) === 1 ? "Enter email" : "أدخل البريد الإلكتروني",
            },
            value: "",
            label: parseInt(localStorage.getItem('language')) === 1 ? "Email" : "البريد الإلكتروني",
            validation: {
                required: true,
                isEmail: true
            },
            valid: false,
            touched: false
        },
        phone: {
            elementType: "input",
            elementConfig: {
                type: "phone",
                placeholder: "07xxxxxxxx",
            },
            value: "",
            valueName: "phone_number",
            validation: {
                required: true,
                isNumeric: true
            },
            label: parseInt(localStorage.getItem('language')) === 1 ? "Phone" : "رقم الهاتف",
            valid: false,
            touched: false
        },
        corporationName: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: parseInt(localStorage.getItem('language')) === 1 ? "Enter name" : "أدخل الاسم",
            },
            value: "",
            validation: {
                required: false,
                minLength: 6,
                maxLength: 32,
            },
            label: parseInt(localStorage.getItem('language')) === 1 ? "Corporation Name" : "اسم المؤسسة",
            valid: false,
            touched: false
        },
        eventDetails: {
            elementType: "textarea",
            elementConfig: {
                type: "textarea",
                placeholder: parseInt(localStorage.getItem('language')) === 1 
                    ? "Please provide a brief description like expected number of attendees, and any special requests or requirements you may have"
                    : "يرجى تقديم وصف موجز مثل العدد المتوقع للحضور، وأي طلبات أو متطلبات خاصة قد تكون لديك",
            },
            value: "",
            label: parseInt(localStorage.getItem('language')) === 1 ? "Event Details" : "تفاصيل الفعالية",
            valid: false,
            touched: false,
        },
    });
    useEffect(() => {
        const updatedControls = {
            ...controls,
            startingDate: {
                ...controls.startingDate,
                availableDates: props.availableSlots

            },
            endingDate: {
                ...controls.endingDate,
                availableDates: props.availableSlots
            }
        };
        setControls(updatedControls);
    }, [props.availableSlots]);
    useEffect(() => {
        controls.startingDate.value.length > 0 && handleDateSelection(controls.startingDate.value);
        controls.endingDate.value.length > 0 && handleDateSelection(controls.endingDate.value);
    }, [controls.startingDate.value, controls.endingDate.value]);
    useEffect(() => {
        const updatedControls = {
            ...controls,
            eventType: {
                ...controls.eventType,
                elementConfig: {
                    ...controls.eventType.elementConfig,
                    options: props.activityTypes?.map(type => ({
                        value: type.id,
                        displayValue: type.name
                    }))
                }
            }
        };
        setControls(updatedControls);
    }, [props.activityTypes]);

    const formElementsArray = [];
    for (let key in controls) {
        formElementsArray.push({
            id: key,
            config: controls[key]
        });
    }
    const form = formElementsArray.map((formElement, i) => (
        <div key={i} className={[classes.FormGroup,
        (formElement.id === "startingDate" || formElement.id === "endingDate") && classes.FormGroupCalendar].join(" ")}>
            <InputField
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                availableDates={formElement.config.availableDates}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                withRemove={false}
                withIcon={formElement.config.withIcon}
                label={formElement.config.label}
                changed={event => inputChangedHandler(event, formElement.id)}
            />
        </div>
    ));
    const checkValidity = ((value, rules) => {
        let isValid = true;
        if (!rules) {
            return true;
        }

        if (rules.required) {
            value = typeof value === 'string' ? value.trim() : value;
            isValid = value !== "" && isValid;
        }

        if (rules.minLength) {
            isValid = value?.length >= rules.minLength && isValid;
        }

        if (rules.maxLength) {
            isValid = value?.length <= rules.maxLength && isValid;
        }

        if (rules.isEmail) {
            const pattern = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
            isValid = pattern.test(value) && isValid;
        }

        if (rules.isNumeric) {
            const pattern = /^\d+$/;
            isValid = pattern.test(value) && isValid;
        }

        return isValid;
    });
    const handleDateSelection = (selectedDate) => {
        const selectedSlots = props.availableSlots.find(
            (slot) => slot.date === selectedDate[0]
        );
        const updatedOptions = selectedSlots
            ? selectedSlots.slots.map((slot) => ({
                value: slot.time,
                displayValue: slot.time,
            }))
            : [];
        const updatedControls = {
            ...controls,
            startingTime: {
                ...controls.startingTime,
                elementConfig: {
                    ...controls.startingTime.elementConfig,
                    options: updatedOptions
                }
            },
            endingTime: {
                ...controls.endingTime,
                elementConfig: {
                    ...controls.endingTime.elementConfig,
                    options: updatedOptions
                }
            },
        };
        setControls(updatedControls);
    };
    const inputChangedHandler = (event, controlName) => {
        const value = controlName === "phone" || controlName === "startingDate" || controlName === "endingDate"
            ? event : event.target.value;
        const updatedControls = {
            ...controls,
            [controlName]: {
                ...controls[controlName],
                value,
                valid: checkValidity(value, controls[controlName].validation),
                touched: true
            }
        };
        setControls(updatedControls);
    };

    const submitHandler = async (e) => {
        e.preventDefault();
        if (!props.isAuthenticated) props.setShowLoginForm(true)
        else {
        setError(null);
        setLoading(true);
        try {
            const formData = {
                type_id: 3,
                event_type: controls.eventType.value,
                start_date: controls.startingDate.value[0],
                end_date: controls.endingDate.value[0],
                start_time: controls.startingTime.value,
                end_time: controls.endingTime.value,
                contact_details: {
                    name: controls.yourName.value,
                    email: controls.email.value,
                    phone: controls.phone.value.dialCode + controls.phone.value.number,
                    corporation_name: controls.corporationName.value,
                },
                corporation_name: controls.corporationName.value,
                special_requests: controls.eventDetails.value,
                event_details: "Team building event",
            };
            const response = await sixYardAxios.post('/activities/book', formData);
            if (response.data) {
                setSuccess(response.data.data.message || 'Your order was submitted successfully. We will reach you soon');
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    }
    };

    const successClicked = () => {
        setSuccess(false);
        window.location.reload();
    }
    return (
        <form className={classes.Container} onSubmit={(e) => submitHandler(e)}>
            {form}
            <p className={classes.Prompt}>
                {parseInt(localStorage.getItem('language')) === 1 
                    ? "Please read and agree to our "
                    : "يرجى قراءة والموافقة على "}
                <a href="/privacy-policy" target='_blank' className={classes.Link}>
                    {parseInt(localStorage.getItem('language')) === 1 
                        ? "Privacy Policy "
                        : "سياسة الخصوصية "}
                </a>
                {parseInt(localStorage.getItem('language')) === 1 ? "and " : "و "}
                <a href="/terms-and-conditions" target='_blank' className={classes.Link}>
                    {parseInt(localStorage.getItem('language')) === 1 ? "Terms" : "الشروط"}
                </a>
            </p>
            <div className={classes.CheckBox}>
                <input type="checkbox" onClick={() => setIsTermsChecked(!isTermsChecked)} />
                <label className={classes.Label}>
                    {parseInt(localStorage.getItem('language')) === 1 
                        ? "I have read and agreed to terms and conditions and privacy policy"
                        : "لقد قرأت ووافقت على الشروط والأحكام وسياسة الخصوصية"}
                </label>
            </div>
            <div>
                <button type="submit" 
                    className={[classes.submitButton, !isTermsChecked && classes.Disabled].join(" ")}
                    disabled={!isTermsChecked}
                >
                    {parseInt(localStorage.getItem('language')) === 1 ? "SUBMIT" : "إرسال"}
                    <img
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/b4d5bcaf1ebb966f9c466b88bc4db272a664766c03afdc1eeb10bad706c68a4a?placeholderIfAbsent=true&apiKey=55c20a0273674f7297318d8ed49e9ee9"
                        alt=""
                        className={classes.submitIcon}
                    />
                </button>
            </div>
            {error && <PromptMessage 
                message={error} 
                status={parseInt(localStorage.getItem('language')) === 1 ? 'Oops' : 'عفواً'} 
                button={parseInt(localStorage.getItem('language')) === 1 ? 'CLOSE' : 'إغلاق'} 
                click={() => setError(false)} 
            />}
            {success && <PromptMessage 
                message={success} 
                status={parseInt(localStorage.getItem('language')) === 1 ? 'CONGRATULATIONS' : 'تهانينا'} 
                successMessage 
                button={parseInt(localStorage.getItem('language')) === 1 ? 'CLOSE' : 'إغلاق'} 
                click={successClicked} 
            />}
        </form>
    )
}
export default Form;